module.exports = __webpack_public_path__ + "media/images/pic/brodno/polygon_news_bigger_bg-1ad473ada1870d30b77b5a6934955f2c.png";